<style src="./style.scss">

</style>

{#if currentSession}
<section class="mbsc-row featured-class">
  <ClassPlayer
    sessionId={currentSession.id}
  ></ClassPlayer>
</section>
{#if subscription && currentSession.id}
<article class="mbsc-row">
  <div class="mbsc-col-12">
    <Disqus
      identifier={currentSession.id}
    ></Disqus>
  </div>
</article>
{/if}
<article class="mbsc-row">
  <div class="mbsc-col-12">
    <div class="mbsc-row">
      <RelatedContent
        title="Otras sesiones que te podrían interesar."
        subtitle="Continua disfrutando de nuestro contenido."
        items={getRelatedContent()}
        actionLabel='Ver'
      ></RelatedContent>
    </div>
  </div>
</article>
{/if}

<script>
import { onMount, afterUpdate } from 'svelte';
import { Navigation, Sessions, AWSAuth, Instructor, AWSAnalytics } from '@Services';

import Disqus from '@Components/Disqus/index.svelte';
import Banner from '@Components/Banner/index.svelte';
import RelatedContent from '@Components/RelatedContent/index.svelte';
// Logged In members
import ClassPlayer from '@Components/ClassPlayer/index.svelte';

export let sessionId = null;

const DEBUG = document.location.protocol === 'http:' ? true : false;

let currentSession = null;
let sessions = [];
let relatedContent = [];
let instructor = [];
const maxRelated = 4;
let subscription = null;

let getInstructor = () => {
  if (!currentSession) {
    return {};
  }

  const roaster = Instructor.getAll();

  roaster.forEach(item => {
    if (item.id === currentSession.details.slug) {
      instructor.push(item);
    }
  });

  return instructor;
};

let getRelatedContent = () => {
  if (!currentSession) {
    return [];
  }
  let relatedSessions = currentSession.related;

  sessions.forEach(session => {
    if (relatedSessions.includes(session.id)) {
      relatedContent.push({
        id: session.id,
        name: session.details.name + ' | D-NS Studio Sessions ' + session.id,
        subtitle: session.details.instructor,
        image: session.details.profile_picture,
        description: session.videoInfo.about,
        slug: '/session/' + session.id + '/',
        featured: session.poster,
        social: {
          fb: [{
            name: session.details.fb,
            link: "http://m.me/" + session.details.fb,
          }]
        },
        about: session.videoInfo.description,
      },);
    }
  });
  return relatedContent;
};

onMount(async () =>{
  AWSAuth.isAnonymous().then(async response => {
    subscription = await AWSAuth.hasValidSubscription();
    sessions = Sessions.getSessions(true);
    sessions.forEach(session => {
      if (session.id === sessionId) {
        currentSession = session;
      }
    });
    if (currentSession === null) {
      Navigation.goTo('classes');
      return;
    }
  });
});
</script>
